import React from 'react';


const Notfound = () => {
    return(
        <>
        <h1>404 - Страница не найдена </h1>
        </>
    )
};


export default Notfound;